package com.tovtalk.domain.repository

import com.tovtalk.domain.entity.DomainResult

interface UploadRepository {
    suspend fun uploadFile(
        bytes: ByteArray,
        filename: String,
        category: String,
        onProgress: ((Float) -> Unit)? = null
    ): DomainResult<UploadResult>
}

data class UploadResult(
    val url: String,
    val path: String
)
